<div class="flex h-screen w-full flex-col overflow-hidden">
  <app-header />

  <main class="flex flex-1 flex-col overflow-hidden">
    <router-outlet />
  </main>
</div>
